import router from '@/router'
import { usePaymentStore } from '@/stores/payment'
import type { SysMsgAttachment } from '@/types/mqtt'

/**
 * 解析系统消息跳转类型。
 * 未传 jumpType 时：有 jumpUrl → H5；有 jumpTargetId → 写作小类；否则无跳转。
 */
export function resolveSysMessageJumpType(attachment: SysMsgAttachment): number {
  if (attachment.jumpType != null) return attachment.jumpType
  if (attachment.jumpUrl) return 3
  if (attachment.jumpTargetId != null) return 1
  return 0
}

/** attachment 是否具备可执行的跳转目标 */
export function canSysMessageJump(attachment?: SysMsgAttachment): boolean {
  if (!attachment) return false

  const jumpType = resolveSysMessageJumpType(attachment)
  switch (jumpType) {
    case 0:
      return false
    case 1:
      return attachment.jumpTargetId != null
    case 3:
      return !!attachment.jumpUrl
    default:
      return true
  }
}

/** 处理系统消息 attachment 跳转 */
export function handleSysMessageJump(attachment?: SysMsgAttachment): void {
  if (!attachment) return

  const jumpType = resolveSysMessageJumpType(attachment)
  if (jumpType === 0) return

  switch (jumpType) {
    case 1:
      if (attachment.jumpTargetId) {
        void router.push({ path: '/zhuli/action', query: { id: String(attachment.jumpTargetId) } })
      }
      break
    case 2:
      void router.push({ path: '/zhuli/article' })
      break
    case 3:
      if (attachment.jumpUrl) {
        window.location.href = attachment.jumpUrl
      }
      break
    case 4:
      usePaymentStore().openDialog('member')
      break
    default:
      break
  }
}
